// frontend/src/components/Charts/MonthlyCashflowChart.jsx
// ✅ VERSIÓN SIMPLIFICADA - Solo Cobrado y Pendiente

import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const MonthlyCashflowChart = ({ data }) => {
  const chartData = {
    labels: data.map(item => {
      // Mostrar "Ene 2026", "Feb 2026", etc.
      const [year, month] = item.month.split('-');
      const monthNames = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
      return `${monthNames[parseInt(month) - 1]} ${year}`;
    }),
    datasets: [
      {
        label: 'Cobrado',
        data: data.map(item => item.collected_amount),
        backgroundColor: 'rgba(45, 206, 137, 0.8)',
        borderColor: 'rgb(45, 206, 137)',
        borderWidth: 1,
      },
      {
        label: 'Pendiente',
        data: data.map(item => item.pending_amount),
        backgroundColor: 'rgba(251, 99, 64, 0.8)',
        borderColor: 'rgb(251, 99, 64)',
        borderWidth: 1,
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          usePointStyle: true,
          padding: 15,
          font: {
            size: 12,
            family: "'Open Sans', sans-serif"
          }
        }
      },
      title: {
        display: true,
        text: 'Cobros por mes (IVA incluido)',
        font: {
          size: 16,
          family: "'Open Sans', sans-serif",
          weight: '600'
        },
        padding: {
          bottom: 20
        }
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        callbacks: {
          label: function(context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            return `${label}${new Intl.NumberFormat('es-MX', {
              style: 'currency',
              currency: 'MXN',
              minimumFractionDigits: 0
            }).format(context.parsed.y)}`;
          },
          footer: function(tooltipItems) {
            const dataIndex = tooltipItems[0].dataIndex;
            const item = data[dataIndex];
            const total = item.collected_amount + item.pending_amount;
            return [
              `Total con IVA: ${new Intl.NumberFormat('es-MX', {
                style: 'currency',
                currency: 'MXN',
                minimumFractionDigits: 0
              }).format(total)}`,
              `Facturas: ${item.invoices_count}`
            ];
          }
        }
      }


    },
    scales: {
      x: {
        stacked: true, // ✅ Barras apiladas para ver el total
        grid: {
          display: false
        },
        ticks: {
          font: {
            size: 11
          }
        }
      },
      y: {
        stacked: true, // ✅ Barras apiladas
        beginAtZero: true,
        grid: {
          borderDash: [2, 2],
          color: 'rgba(0, 0, 0, 0.05)'
        },
        ticks: {
          font: {
            size: 11
          },
          callback: function(value) {
            return new Intl.NumberFormat('es-MX', {
              style: 'currency',
              currency: 'MXN',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }).format(value);
          }
        }
      }
    }
  };

  return (
    <div style={{ height: '400px', width: '100%' }}>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default MonthlyCashflowChart;
